import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-charcoal-950 py-12 sm:py-16" aria-labelledby="guarantee-title" data-id="element-154" data-mp="4uqdmw6js2tb">
      <div className="mx-auto max-w-2xl px-5 text-center" data-id="element-155" data-mp="9tbduvlsumhr">
        <ShieldCheckIcon className="mx-auto h-8 w-8 text-champagne" strokeWidth={1.25} aria-hidden="true" data-id="element-156" data-mp="etfy8wptw1d9" />
        <h2 id="guarantee-title" className="mt-4 font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-157" data-mp="jrr651wkc1su">
          Garantía — 7 días, sin preguntas
        </h2>
        <p className="mx-auto mt-3 max-w-lg text-[14px] leading-relaxed text-body sm:text-[15px]" data-id="element-158" data-mp="smxf29r4qzzl">
          Abre las recetas. Cocina en tu cocina. Si en 7 días no es lo que esperabas:{' '}
          <span className="text-ivory-100" data-id="element-159" data-mp="12kv24tx96qqm">
            reembolso 100% — sin formularios, sin drama.
          </span>
        </p>
        <p className="mt-5 text-[10px] font-semibold uppercase tracking-[0.2em] text-muted" data-id="element-160" data-mp="25rxa8qlgj00k">
          Tasa de devoluciones: menos del 1%
        </p>
      </div>
    </section>;
}